"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetClass = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.DatasetClass = {
    SIMPLE_DATASET: 'SIMPLE_DATASET',
    ADVANCED_DATASET: 'ADVANCED_DATASET',
    CATEGORIZED_DATASET: 'CATEGORIZED_DATASET',
    ELECTRICITY_DATASET: 'ELECTRICITY_DATASET',
    PROCESSED_DATASET: 'PROCESSED_DATASET',
    PROCESSED_INTEGRAL_DATASET: 'PROCESSED_INTEGRAL_DATASET',
    PROCESSED_PRIORITY_FIRST_DATASET: 'PROCESSED_PRIORITY_FIRST_DATASET',
    PROCESSED_PYTHON_DATASET: 'PROCESSED_PYTHON_DATASET',
    CATEGORIZED_STRING_DATASET: 'CATEGORIZED_STRING_DATASET',
    REMOTE_DATASET: 'REMOTE_DATASET',
    REMOTE_STRING_DATASET: 'REMOTE_STRING_DATASET',
    REMOTE_CATEGORIZED_DATASET: 'REMOTE_CATEGORIZED_DATASET'
};
//# sourceMappingURL=dataset-class.js.map